import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const FilterText = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: #004f92;
  cursor: pointer;
`;

export const CloseDiv = styled.div`
  margin-left: 12px;
  cursor: pointer;
  width: 24px;
  height: 24px;
`;

export const BlueContainer = styled.div`
  display: flex;
  background-color: #ebf7fd;
  border-radius: 16px;
  align-items: center;
  justify-content: space-between;
  height: 34px;
  width: 150px;
  padding: 10px 12px;
  cursor: pointer;
`;

export const RoundedDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  height: 20px;
  width: 24px;
  background-color: var(--blue-einstein);
`;

export const CounterText = styled.p`
  ${({ theme }) => css`
    font-size: 12px;
    font-weight: ${theme.fontWeight.bold};
    color: var(--background-color);
  `}
`;
